import {
	MeasurableValueDTO,
	RootCauseWidgetEmissionFactorChangesFuelItemDTO,
	RootCauseWidgetEmissionFactorChangesVehicleItemDTO,
} from "../../../../../../../../../datasources/api-client/data-contracts";

export type EnergyChartItem = {
	id: string;
	label: string;
	categoryLabel?: string;
	baseline: {
		share: MeasurableValueDTO;
		intensity: MeasurableValueDTO;
		co2: MeasurableValueDTO;
	};
	comparison: {
		share: MeasurableValueDTO;
		intensity: MeasurableValueDTO;
		co2: MeasurableValueDTO;
	};
};
export const mapVehicleToEnergyChartItem = (
	item: RootCauseWidgetEmissionFactorChangesVehicleItemDTO
): EnergyChartItem => ({
	id: `vehicle-${item.categoryId}-${item.sizeId}`,
	label: item.categoryLabel + " - " + item.sizeLabel,
	categoryLabel: item.categoryLabel ?? undefined,
	baseline: {
		share: item.baseTkmShare,
		intensity: item.baseMjTkm,
		co2: item.baseCo2,
	},
	comparison: {
		share: item.compTkmShare,
		intensity: item.compMjTkm,
		co2: item.compCo2,
	},
});

export const mapFuelToEnergyChartItem = (item: RootCauseWidgetEmissionFactorChangesFuelItemDTO): EnergyChartItem => ({
	id: `fuel-${item.energyClassId}`,
	label: item.energyClassLabel,
	categoryLabel: item.energyClassCategoryLabel ?? undefined,
	baseline: {
		share: item.baseTkmShare,
		intensity: item.baseCo2Mj,
		co2: item.baseCo2,
	},
	comparison: {
		share: item.compTkmShare,
		intensity: item.compCo2Mj,
		co2: item.compCo2,
	},
});
